Searches = LP.module('Searches')

SEARCH_TAB_ID_PARAM = "search_tab_id"

class SearchResultsLoader extends FluxBaseStore
  @storeName: 'SearchResultsLoader'

  @handlers:
    TOGGLE_FACET:  'toggleFacet'
    HIDE_RESOURCE: 'hide'
    RECEIVE_SEARCH: 'updatePage'

  initialize: ->
    paramStore = @dispatcher.getStore('ParamStore')
    @_search_tab_id = paramStore.get(SEARCH_TAB_ID_PARAM)

  toggleFacet: ({facet} = {facet: null}) ->
    @._waitForVideoStore()
    return unless @._valid()
    $(".resource-card-loader").addClass('loading')
    $('#js-search-heading').addClass('invisible')

  hide: ({query} = {query: null}) ->
    @._waitForVideoStore()
    if @._valid(query)
      $(".resource-card-loader").addClass('loading')
      $('#js-search-heading').addClass('invisible')

  updatePage: ({rawSearch, paramsDidChange} = {rawSearch: {}, paramsDidChange: null}) ->
    @._waitForVideoStore()
    $('#js-search-heading').removeClass('invisible') unless @._valid()
    return unless @._valid()
    $(".resource-card-loader").removeClass('loading')

  _waitForVideoStore: ->
    try
      @dispatcher.waitFor 'VideoModeStore'
    catch

  _valid: (query) ->
    if query? && query.includes(SEARCH_TAB_ID_PARAM)
      query_search_tab_id = @._search_tab_id_from_query(query)
      isValid = @_search_tab_id != query_search_tab_id
      @_search_tab_id = query_search_tab_id
      return isValid

    try
      boclipsStore = @dispatcher.getStore('VideoModeStore')
      boclipsStore.currentState().valid
    catch

  _search_tab_id_from_query: (query) ->
    query.split("#{SEARCH_TAB_ID_PARAM}=")[1].split("&")[0]

Searches.SearchResultsLoader = SearchResultsLoader
